module.exports = __webpack_public_path__ + "img/empty-search.be9b2aca.webp";